import React from "react";
import "./context/styles/themes.css"; // Adjust the path if necessary
import { BrowserRouter, Router, Routes, Route, useLocation } from "react-router-dom";
// import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import ThemeProvider from "./context/ThemeContext";
import { AuthProvider } from "./context/AuthContext";
import AppRoutes from "./AppRoutes";
import { AnimatePresence } from 'framer-motion';
import { MediaDisplayProvider } from "./context/MediaDisplayModeContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BetaProvider, useBeta } from "./context/BetaContext"; // ✅ add this

import PublicLayout from "./Layout/PublicLayout"; // Layout for public pages
import PrivateLayout from "./Layout/PrivateLayout"; // Layout for private pages
import Error from "./components/common/Error";

const App = () => {
  return (
    <ThemeProvider>
      <AuthProvider>
        <MediaDisplayProvider>
          <BetaProvider>
            <BrowserRouter>
              <ToastContainer position="top-center" autoClose={3000} />
              <AppRoutes />  {/* ✅ Extracted Routes into a component */}
            </BrowserRouter>
          </BetaProvider>
        </MediaDisplayProvider>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
